import React from 'react';
import { withApollo } from 'react-apollo';
import gqlQueryGetUploadInfo from 'graphql/queries/get-upload-info';
import _get from 'lodash/get';

import FileUpload from 'components/file-upload';

import { captureException } from '../../services/sentry';

function S3FileUpload(props) {
  const getUploadInfo = (variables) => {
    const { client } = props;
    return client.query({
      query: gqlQueryGetUploadInfo,
      variables
    });
  };

  const prepareFormData = (file) => {
    const formData = new FormData();
    formData.append('key', file.name);
    formData.append('file', file, file.name);
    return formData;
  };

  const prepareXHR = (request, uploadUrl, progress, load, error) => {
    captureException(error);

    const { onUpload } = props;

    request.open('PUT', uploadUrl);
    // Should call the progress method to update the progress to 100% before calling load
    // Setting computable to false switches the loading indicator to infinite mode
    request.upload.onprogress = (e) => {
      progress(e.lengthComputable, e.loaded, e.total);
    };
    // Should call the load method when done and pass the returned server file id
    // this server file id is then used later on when reverting or restoring a file
    // so your server knows which file to return without exposing that info to the client
    request.onload = () => {
      if (request.status >= 200 && request.status < 300) {
        // notify parent component that file is uploaded
        if (onUpload) {
          onUpload();
        }
        // the load method accepts either a string (id) or an object
        load(request.responseText);
      } else {
        // Can call the error method if something is wrong, should exit after
        error('Request failed! Please try again.');
      }
    };
  };

  const prepareFileUploadProps = () => {
    return {
      server: {
        process: (fieldName, file, metadata, load, error, progress, abort) => {
          progress(true, 0.1, 1);

          const request = new XMLHttpRequest();

          // fetch upload info
          const uploadInfoRequest = getUploadInfo({
            fileName: file.name.replace(/\s/g, '-'),
            uploadType: 'USER_SEGMENT_LIST'
          });

          uploadInfoRequest
            .then((responseData) => {
              const uploadInfo = _get(responseData, 'data.getUploadInfo');

              if (!uploadInfo) {
                error('Request failed! Please try again.');
                return;
              }
              const { uploadUrl } = uploadInfo;

              const formData = prepareFormData(file);

              prepareXHR(request, uploadUrl, progress, load, error);

              if (!request.aborted) {
                request.send(formData);
              }
            })
            .catch((e) => {
              error(e);
            });

          // Should expose an abort method so the request can be cancelled
          // eslint-disable-next-line consistent-return
          return {
            abort() {
              // This function is entered if the user has tapped the cancel button
              request.abort();
              request.aborted = true;
              // Let FilePond know the request has been cancelled
              abort();
            }
          };
        }
      }
    };
  };

  const fileUploadProps = prepareFileUploadProps();
  const { client, onUpload, ...rest } = props;
  return (
    <>
      <FileUpload {...rest} {...fileUploadProps} />
    </>
  );
}

export default withApollo(S3FileUpload);
